import React from 'react'
import PropTypes from 'prop-types'
import {
  AlertTriangle,
  CircleCheck,
  Info,
  CircleX,
} from '@entrata/portals-common/lib/icons'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

const fullscreenStyle = css`
  width: 100vw;
  margin-left: calc(-50vw + 50%);
`

const StyledDiv = styled('div')`
  width: 100%;

  background-color: ${({ theme, type }) =>
        theme.system_message[type] &&
        theme.system_message[type].background_color};
  color: ${({ theme }) => theme.system_message.font};
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 8px 16px 8px 16px;
  border-radius: 8px;
  justify-content: flex-start;

  ${({ fullscreen }) => fullscreen && fullscreenStyle}

  em {
    font-size: 13px;
    font-style: normal;
    font-weight: 300;
    line-height: 1.5;
    width: auto;
  }
`

const StyledIcon = styled('span')`
  line-height: 1;
  margin-right: 16px;
  svg {
    color: ${({ theme, type }) =>
      theme.system_message[type] && theme.system_message[type].color};
  }
`

function SystemMessage({
  children,
  fullscreen,
  type,
  shouldScrollOnMount,

  ...props
}) {
  const Icon =
    type === 'success'
      ? CircleCheck
      : type === 'info'
        ? Info
        : type === 'error'
          ? CircleX
          : AlertTriangle
  const el = React.useRef()

  React.useEffect(() => {
    if (shouldScrollOnMount) {
      typeof el.current.scrollIntoView == 'function' &&
        el.current.scrollIntoView(false)
    }
  }, [])
  return (
    <StyledDiv
      className={props.className}
      ref={el}
      type={type}
      fullscreen={fullscreen}
    >
      <StyledIcon type={type}>
        <Icon size='18' aria-hidden='true' />
      </StyledIcon>
      {children.message ? <em>{children.message}</em> : <em>{children}</em>}
    </StyledDiv>
  )
}

SystemMessage.propTypes = {
  /** Message to show to user */
  children: PropTypes.any.isRequired,
  /** Whether the message should break out of it's container to span the entire screen. Really only useful on small screens with centered content */
  fullscreen: PropTypes.bool,
  /** Message type */
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired,
  /** If true, body will scroll to display message when it appears */
  shouldScrollOnMount: PropTypes.bool,
  className: PropTypes.string,
}

export default SystemMessage
